/**
 * AlertNotifications Component
 *
 * Fixed-position success/error alert notifications
 */

import React from 'react';
import { Box, Alert, Slide } from '@mui/material';

export interface AlertNotificationsProps {
    error: string | null;
    success: string | null;
    onCloseError?: () => void;
    onCloseSuccess?: () => void;
}

export const AlertNotifications: React.FC<AlertNotificationsProps> = ({
    error,
    success,
    onCloseError,
    onCloseSuccess,
}) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 80,
                right: 24,
                zIndex: 1300,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                maxWidth: 400,
            }}
        >
            <Slide direction="left" in={!!error} mountOnEnter unmountOnExit>
                <Alert
                    severity="error"
                    onClose={onCloseError}
                    sx={{
                        boxShadow: '0 4px 20px rgba(239, 68, 68, 0.3)',
                        borderRadius: 2,
                    }}
                >
                    {error}
                </Alert>
            </Slide>
            <Slide direction="left" in={!!success} mountOnEnter unmountOnExit>
                <Alert
                    severity="success"
                    onClose={onCloseSuccess}
                    sx={{
                        boxShadow: '0 4px 20px rgba(34, 197, 94, 0.3)',
                        borderRadius: 2,
                    }}
                >
                    {success}
                </Alert>
            </Slide>
        </Box>
    );
};

export default AlertNotifications;
